import React from 'react';
import ArchivedTable from '../components/ArchivedTable';

const AppList = () => {
  return (
    <div className="p-6" style={{ backgroundColor: '#C6D2ED', minHeight: '100vh' }}>
      <ArchivedTable />
    </div>
  );
};

export default AppList;